'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export interface OffcanvasCloseButtonProps {
  onCloseClick: () => void;
}
function OffcanvasCloseButton(t0) {
  const $ = _c(4);
  const {
    onCloseClick
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="sr-only">Close menu</span>;
    t2 = <Icon name={IconName.CLOSE} className="text-4xl!" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onCloseClick) {
    t3 = <div className="px-4 pt-5 pb-2 flex justify-end"><button type="button" className="-m-2 p-2 inline-flex items-center justify-center text-black" onClick={onCloseClick}>{t1}{t2}</button></div>;
    $[2] = onCloseClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default OffcanvasCloseButton;